<template>
    <SwContainer v-if="offers && offers.length > 0">
        <div :class="$style['card']">
            <SwContainer :class="$style['card__carousel']" pa0>
                <div style="position: sticky; top: 80px;">
                    <div :class="$style['card__labels']">
                        <ProductLabelList :labels="labels" />
                    </div>
                    <ProductPreview v-if="previews && previews.length > 0" :items="previews" />
                    <SwImagePlaceholder v-else wide />
                </div>
            </SwContainer>

            <SwContainer :class="$style['card__summary']" pa0>
                <ProductSummary
                    :name="name"
                    :article="article"
                    :manufacturer="manufacturer"
                    :description="description"
                    :labels="labels"
                    :offers="offers"
                    :show-characteristic="showCharacteristic"
                    :type="type"
                    :bonuses-credit="bonusesCredit"
                    @updateImages="images = $event"
                />
            </SwContainer>
        </div>
    </SwContainer>
</template>

<script>
import ProductPreview from './ProductCard/ProductPreview'
import ProductSummary from './ProductCard/ProductSummary'
import ProductLabelList from '@@/website/components/common/ProductLabelList'

export default {
  name: 'ProductCard',

  components: {
    ProductLabelList,
    ProductPreview,
    ProductSummary
  },

  props: {
    name: {
      type: String,
      default: ''
    },

    type: {
      type: String,
    },

    article: {
      type: String,
      default: ''
    },

    manufacturer: {
      type: String,
      default: ''
    },

    description: {
      type: String,
      default: ''
    },

    labels: {
      type: Array,
      default: () => []
    },

    offers: {
      type: Array,
      default: () => []
    },

    showCharacteristic: {
      type: Boolean,
      default: false
    },

    bonusesCredit: {
      type: Number,
      default: 0
    },
  },

  data: () => ({
    images: []
  }),

  computed: {
    previews () {
      return this.images.length > 0
        ? this.images
        : this.offers?.length
          ? this.offers[0].images
          : []
    }
  }
}
</script>

<style lang="less" module>
@import (reference) "@@/assets/Web.less";

.card {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  &__carousel {
    justify-content: flex-start;
    max-width: 492px;
    min-height: 570px;
    margin-right: 48px;
    @media screen and (max-width: @bp-tablet) {
      max-width: calc(50% - 16px);
      margin-right: 16px;
    }
    @media screen and (max-width: @bp-mobile-small) {
      max-width: 100%;
      min-height: auto;
      margin-right: 0;
      margin-bottom: 20px;
    }
  }

  &__labels {
    display: none;
    position: absolute;
    @media screen and (max-width: @bp-mobile-small) {
      display: flex;
      top: -10px;
      left: 12px;
      z-index: 1;
    }
  }

  &__summary {
    max-width: 516px;
    min-height: 570px;
    @media screen and (max-width: @bp-tablet) {
      max-width: calc(50% - 16px);
    }

    @media screen and (max-width: @bp-mobile-small) {
      max-width: 100%;
      min-height: auto;
    }
  }
}
</style>
